import { defaultTheme } from 'react-admin'

export const kampaayTheme = {
  ...defaultTheme,
  palette: {
    ...defaultTheme.palette,
    primary: {
      light: '#fc957b', // used by react-admin, don't touch
      main: '#FF714D', // used by react-admin, don't touch
      dark: '#e04d28', // used by react-admin, don't touch
      contrastText: '#fff', // used by react-admin, don't touch
      white: '#fff',
      lightBlack: '#E0E0E0',
      lighterBlack: '#f9f9f9',
    },
    secondary: {
      light: '#fc957b', // used by react-admin, don't touch
      main: '#FF714D', // used by react-admin, don't touch
      dark: '#e04d28', // used by react-admin, don't touch
      contrastText: '#fff', // used by react-admin, don't touch
    },
  },
}
